import React, { useState, Fragment, useEffect, useRef } from 'react';

import { Modal } from 'flowbite';

import NonWorkforceCostsSection from './partial/NonWorkforceCostsSection';

import { parseLocaleNumber } from 'Helpers/currencyFormat';
import { modalOptions } from 'Helpers/modalOptions';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';
import SimpleConfirmationModal from 'CommonComponents/SimpleConfirmationModal';

import PlusIcon from 'Assets/icons/plus.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function InputsEventExpenditure(props) {
    const [deletedRow, setDeletedRow] = useState({});
    const [inputExpenditureConfirmDeleteRowModalElement, setInputExpenditureConfirmDeleteRowModalElement] = useState(null);

    const inputExpenditureConfirmDeleteRowModalRef = useRef();

    useEffect(() => {
        inputExpenditureConfirmDeleteRowModalRef &&
            setInputExpenditureConfirmDeleteRowModalElement(new Modal(inputExpenditureConfirmDeleteRowModalRef.current, modalOptions(false)));
    }, []);

    const changeInput = (e, group, subGroup, rowKey = null, key = null) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;

        if (rowKey) {
            if (key) {
                data[group][subGroup][rowKey][key] = val;
            } else {
                data[group][subGroup][rowKey] = val;
            }
        } else {
            data[group][subGroup] = val;
        }

        props.changeHandler(data);
    };

    const changeNonWorkforce = (e, departmentId, key, ccId = null, expenseId = null) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;

        if (expenseId) {
            if (ccId) {
                data.os_expenditure.non_workforce_costs.departments[departmentId].costcenters[ccId].expenses[expenseId].data[key] = val;
            } else {
                data.os_expenditure.non_workforce_costs.departments[departmentId].expenses[expenseId].data[key] = val;
            }
        } else {
            if (ccId) {
                data.os_expenditure.non_workforce_costs.departments[departmentId].costcenters[ccId].data[key] = val;
            } else {
                data.os_expenditure.non_workforce_costs.departments[departmentId].data[key] = val;
            }
        }

        props.changeHandler(data);
    };

    const changeOtherDescription = (e, category, index) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = e.target.value;
        let row = data[category][index];
        row = _.mapKeys(row, (value, key) => val);
        data[category][index] = row;
        props.changeHandler(data);
    };

    const changeOtherValue = (e, category, index, key, valueKey) => {
        const data = JSON.parse(JSON.stringify(props.data));
        let val = parseLocaleNumber(e.target.value);
        val = Number.isNaN(val) ? 0 : val;
        data[category][index][key][valueKey] = val;
        props.changeHandler(data);
    };

    const addOtherLine = (e, category) => {
        e.preventDefault();
        const data = JSON.parse(JSON.stringify(props.data));
        data[category].push({ '': defaultData() });
        props.changeHandler(data);
    };

    const defaultData = () => {
        return {
            indirect_percent: 0,
            induced_percent: 0,
            international_percent: 0,
            local_percent: 0,
            national_percent: 0,
            value: 0,
        };
    };

    const setDeleted = (category, index, entity) => {
        setDeletedRow({
            category,
            index,
            entity,
        });
        inputExpenditureConfirmDeleteRowModalElement && inputExpenditureConfirmDeleteRowModalElement.show();
    };

    const deleteRow = () => {
        if (Object.keys(deletedRow).length) {
            let data = JSON.parse(JSON.stringify(props.data));

            data[deletedRow.category] = data[deletedRow.category].filter((item, ind) => {
                return ind != deletedRow.index;
            });
            props.changeHandler(data);
        }

        inputExpenditureConfirmDeleteRowModalElement && inputExpenditureConfirmDeleteRowModalElement.hide();
        setDeletedRow({});
    };

    const closeHandler = () => {
        inputExpenditureConfirmDeleteRowModalElement && inputExpenditureConfirmDeleteRowModalElement.hide();
        setDeletedRow({});
    };

    const groups = [
        { os_expenditure: '1. OC expenditure (excl. items on page 1)' },
        { other_games_related_expenditure: '2. Other Games Related Expenditure' },
        { capital_investment: '3. Capital Investment' },
    ];

    const subGroups = {
        os_expenditure: ['workforce', props.event.impact_linked_to_budget ? 'non_workforce_costs' : 'event_production'],
        other_games_related_expenditure: [],
        capital_investment: [],
    };

    const rows = {
        workforce: [{ employee_cost: 'Employee Cost' }],
        event_production: [
            { venue_rental: 'Venue Rental' },
            { venue_overlay: 'Venue Overlay' },
            { venue_operations: 'Venue Operations' },
            { technology: 'Technology' },
            { marketing_and_communications: 'Marketing & Communications' },
            { other: 'Other' },
        ],
    };

    const cellKeys = ['local_percent', 'national_percent', 'international_percent', 'indirect_percent', 'induced_percent'];

    return (
        <div className="table__card">
            <h2 className="table__header tw-mb-6">{$t('Economic - Event Expenditure')}</h2>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-border-r-2" rowSpan={2}>
                                {$t('Economic - Event Expenditure')}
                            </th>
                            <th className="!tw-pb-1.5 !tw-font-extrabold tw-border-r-2 tw-uppercase" colSpan={6}>
                                {$t('Inputs')}
                            </th>
                            <th className="!tw-pb-1.5 !tw-font-extrabold tw-uppercase" colSpan={3}>
                                {$t('Outputs')}
                            </th>
                        </tr>
                        <tr className="*:!tw-pt-1.5">
                            <th>{$t('Value')}</th>
                            <th>{$t('Local')}</th>
                            <th>{$t('National')}</th>
                            <th>{$t('International')}</th>
                            <th>{$t('Indirect')}</th>
                            <th className="tw-border-r-2">{$t('Induced')}</th>
                            <th>{$t('Total Direct')}</th>
                            <th>{$t('Total Indirect')}</th>
                            <th>{$t('Total Induced')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {groups.map((group, index) => {
                            const groupKey = Object.keys(group)[0];
                            const groupTitle = Object.values(group)[0];

                            return (
                                <Fragment key={groupKey}>
                                    {subGroups[groupKey].length > 0 && (
                                        <>
                                            <tr className="tw-font-semibold">
                                                <td className="!tw-border-r-0">{$t(groupTitle)}</td>
                                                <td colSpan={100}>{props.format(props.totalEventExpenditure)}</td>
                                            </tr>
                                            {subGroups[groupKey].map((subGroup) => {
                                                if (subGroup !== 'non_workforce_costs') {
                                                    return (
                                                        <Fragment key={groupKey + '_' + subGroup}>
                                                            <tr className="!tw-bg-white tw-font-medium">
                                                                <td colSpan={100}>{$t(_.startCase(subGroup.replace('_', ' ')))}</td>
                                                            </tr>
                                                            {rows[subGroup].map((row) => {
                                                                const rowKey = Object.keys(row)[0];
                                                                const rowTitle = Object.values(row)[0];

                                                                const value =
                                                                    rowKey === 'other' ? props.totalOther : props.data[groupKey][subGroup][rowKey].value;

                                                                const localPercent = props.data[groupKey][subGroup][rowKey].local_percent;
                                                                const indirectPercent = props.data[groupKey][subGroup][rowKey].indirect_percent;
                                                                const inducedPercent = props.data[groupKey][subGroup][rowKey].induced_percent;
                                                                const totalDirect = (value * localPercent) / 100;
                                                                const totalIndirect = (totalDirect * indirectPercent) / 100;
                                                                const totalInduced = (totalDirect * inducedPercent) / 100;

                                                                return (
                                                                    <tr key={groupKey + '_' + subGroup + '_' + rowKey} className="!tw-bg-blue-25/20">
                                                                        <td>{rowTitle}</td>
                                                                        <td>
                                                                            {rowKey === 'other' && <div>{props.format(value)}</div>}
                                                                            {rowKey !== 'other' && (
                                                                                <NumberFormat
                                                                                    thousandSeparator={true}
                                                                                    inputMode="numeric"
                                                                                    className="text-input"
                                                                                    value={props.data[groupKey][subGroup][rowKey].value}
                                                                                    onChange={(e) => {
                                                                                        changeInput(e, groupKey, subGroup, rowKey, 'value');
                                                                                    }}
                                                                                    disabled={
                                                                                        groupKey === 'os_expenditure' &&
                                                                                        subGroup === 'workforce' &&
                                                                                        rowKey === 'employee_cost'
                                                                                    }
                                                                                />
                                                                            )}
                                                                        </td>

                                                                        {cellKeys.map((cellKey) => {
                                                                            return (
                                                                                <td key={groupKey + '_' + subGroup + '_' + rowKey + '_' + cellKey}>
                                                                                    <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                                                                        <input
                                                                                            className="text-input"
                                                                                            type={'number'}
                                                                                            value={props.data[groupKey][subGroup][rowKey][cellKey]}
                                                                                            min="0"
                                                                                            max="100"
                                                                                            onChange={(e) => {
                                                                                                changeInput(e, groupKey, subGroup, rowKey, cellKey);
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                            );
                                                                        })}
                                                                        <td>{props.format(totalDirect)}</td>
                                                                        <td>{props.format(totalIndirect)}</td>
                                                                        <td>{props.format(totalInduced)}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </Fragment>
                                                    );
                                                } else {
                                                    return (
                                                        <NonWorkforceCostsSection
                                                            key={groupKey + '_' + subGroup}
                                                            groupKey={groupKey}
                                                            subGroup={subGroup}
                                                            data={props.data}
                                                            cellKeys={cellKeys}
                                                            changeInput={changeNonWorkforce}
                                                            format={props.format}
                                                        />
                                                    );
                                                }
                                            })}
                                        </>
                                    )}
                                    {subGroups[groupKey].length === 0 && (
                                        <>
                                            {[''].map((vv) => {
                                                const data = props.data[groupKey];

                                                let totalValue = 0;
                                                let localTotal = 0;
                                                let nationalTotal = 0;
                                                let internationalTotal = 0;
                                                let indirectTotal = 0;
                                                let inducedTotal = 0;
                                                let directTotal = 0;

                                                return (
                                                    <Fragment key={groupTitle}>
                                                        <tr>
                                                            <td className="tw-font-semibold" colSpan={100}>
                                                                <div className="tw-flex tw-items-center tw-gap-x-2">
                                                                    {$t(groupTitle)}
                                                                    <button className="table__icon-btn small" onClick={(e) => addOtherLine(e, groupKey)}>
                                                                        <PlusIcon className="tw-w-2.5 tw-h-2.5" />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        {data.map((row, rowIndex) => {
                                                            const rowData = Object.values(row);
                                                            const rowName = Object.keys(row)[0];

                                                            const value = rowData[0].value || '0';
                                                            const localPercent = rowData[0].local_percent || '0';
                                                            const nationalPercent = rowData[0].national_percent || '0';
                                                            const totalNational = (parseFloat(value) * parseFloat(nationalPercent)) / 100;
                                                            const internationalPercent = rowData[0].international_percent || '0';
                                                            const totalInternational = (parseFloat(value) * parseFloat(internationalPercent)) / 100;

                                                            const indirectPercent = rowData[0].indirect_percent || '0';
                                                            const inducedPercent = rowData[0].induced_percent || '0';
                                                            const totalDirect = (parseFloat(value) * parseFloat(localPercent)) / 100;
                                                            const totalIndirect = (totalDirect * parseFloat(indirectPercent)) / 100;
                                                            const totalInduced = (totalDirect * parseFloat(inducedPercent)) / 100;

                                                            totalValue += parseFloat(value);
                                                            localTotal += totalDirect;
                                                            directTotal += totalDirect;

                                                            nationalTotal += totalNational;
                                                            internationalTotal += totalInternational;
                                                            indirectTotal += totalIndirect;
                                                            inducedTotal += totalInduced;

                                                            return (
                                                                <tr className="!tw-bg-white" key={`${groupTitle}_${rowIndex}`}>
                                                                    <td>
                                                                        <div className="tw-flex tw-gap-x-2">
                                                                            <input
                                                                                className="text-input"
                                                                                type={'text'}
                                                                                value={rowName}
                                                                                placeholder={$t('Enter line description name')}
                                                                                onChange={(e) => {
                                                                                    changeOtherDescription(e, groupKey, rowIndex);
                                                                                }}
                                                                            />
                                                                            {data.length > 1 && (
                                                                                <button className="tw-text-red" onClick={(e) => setDeleted(groupKey, rowIndex)}>
                                                                                    <TrashIcon className="tw-w-3 tw-h-3" />
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <NumberFormat
                                                                            thousandSeparator={true}
                                                                            inputMode="numeric"
                                                                            className="text-input"
                                                                            value={rowData[0].value}
                                                                            onChange={(e) => {
                                                                                changeOtherValue(e, groupKey, rowIndex, rowName, 'value');
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    {cellKeys.map((cellKey) => {
                                                                        return (
                                                                            <td key={groupKey + '_' + cellKey}>
                                                                                <div className="tw-relative after:tw-content-['%'] after:tw-absolute after:tw-right-2 after:tw-top-1/2 after:-tw-translate-y-1/2">
                                                                                    <input
                                                                                        className="text-input"
                                                                                        type={'number'}
                                                                                        value={rowData[0][cellKey]}
                                                                                        min="0"
                                                                                        max="100"
                                                                                        onChange={(e) => {
                                                                                            changeOtherValue(e, groupKey, rowIndex, rowName, cellKey);
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        );
                                                                    })}
                                                                    <td>{props.format(totalDirect)}</td>
                                                                    <td>{props.format(totalIndirect)}</td>
                                                                    <td>{props.format(totalInduced)}</td>
                                                                </tr>
                                                            );
                                                        })}

                                                        <tr className="!tw-bg-charcoal tw-text-white" key={`${groupTitle}_total`}>
                                                            <td>{$t('Total')}</td>
                                                            <td>{props.format(totalValue)}</td>
                                                            <td>{props.format(localTotal)}</td>
                                                            <td>{props.format(nationalTotal)}</td>
                                                            <td>{props.format(internationalTotal)}</td>
                                                            <td>{props.format(indirectTotal)}</td>
                                                            <td>{props.format(inducedTotal)}</td>
                                                            <td>{props.format(directTotal)}</td>
                                                            <td>{props.format(indirectTotal)}</td>
                                                            <td>{props.format(inducedTotal)}</td>
                                                        </tr>
                                                    </Fragment>
                                                );
                                            })}
                                        </>
                                    )}
                                </Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <SimpleConfirmationModal
                closeHandler={closeHandler}
                successHandler={deleteRow}
                allowAction={Object.keys(deletedRow).length > 0}
                modalId={'inputs-expenditure-delete-row'}
                modalRef={inputExpenditureConfirmDeleteRowModalRef}
                modalElement={inputExpenditureConfirmDeleteRowModalElement}
                confirmationMsg={'Are you sure you want to delete this ' + deletedRow?.entity + '?'}
                title={'Delete ' + deletedRow?.entity}
                cancelButtonText={$t('Cancel')}
                primaryButtonText={$t('OK')}
            />
        </div>
    );
}
